<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'BasicModal',
    inheritAttrs: false,
    emits: ['confirm', 'cancel'],
});
</script>

<template>
    <vue-final-modal
        v-slot="{ params, close }"
        v-bind="$attrs"
        classes="bm-container"
        content-class="bm-content"
        style="position: fixed;"
    >

        <div class="bm-title siteTitle">
            <slot name="title"></slot>
        </div>

        <div class="bm-inner">
            <slot :params="params"></slot>
        </div>

        <div class="bm-actions">
            <slot name="actions">
                <button @click="$emit('cancel', close)">Cancel</button>
                <button @click="$emit('confirm', close)">OK</button>
            </slot>
        </div>

        <button class="bm-closeBtn" @click="close">
            <i class="fa-regular fa-xmark" aria-hidden="true"></i>
        </button>

    </vue-final-modal>
</template>


<style lang="scss" scoped>
@import "../setup/vars";
@import "../setup/mixins";

::v-deep(.bm-container) {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed !important;

    .bm-content {
        position: fixed;
        overflow-y: auto;
        min-width: 320px;
        max-width: 640px;
        max-height: calc(100vh - 4rem);
        padding: 2rem;
        background-color: white;
        border-radius: 2px;
        box-shadow: 0 10px 40px rgba(black, 0.2);

        & > *:empty {
            display: none;
        }
    }
}

.bm-title {
    margin: 0 0 2rem;
    padding-right: 3rem;
    font-family: $f_secondary;
    text-transform: uppercase;
    font-size: calc(2rem + 0.2vw + 0.2vh);
    font-weight: 700;
    em {
        font-style: normal;
        font-weight: bolder;
        color: black;
    }
}

.bm-actions {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-end;
    button {
        margin: 1rem 0 0;
        & + button {
            margin-left: 1rem;
        }
    }
}

.bm-closeBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    width: 5rem;
    height: 5rem;
    padding: 0;
    margin: 0;
    color: $c_dark;
    &:hover, &:focus {
        color: black;
    }
}

</style>
